import { IconButton } from '@/components/atoms/Button';
import { Box } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

export const LogoWrapper = styled(Box)(({ theme, open }: { theme: Theme; open: boolean }) => ({
  display: 'flex',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  gap: theme.spacing(1.5),
  padding: theme.spacing(2, 0),
  pl: !open ? 0 : theme.spacing(1),
}));

export const LogoButton = styled(IconButton)(({ open }: { open: boolean }) => ({
  width: '60px',
  height: '60px',
  ml: !open ? 0 : '-8px',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}));
